import React from 'react'
import stylesheet from "./button.module.css"

function Button(props) {
    return <button className={`w-${props.width} ${stylesheet.button}`} onClick={()=>{props.func()}}>{props.value}</button>
}

export default Button